"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EffluentPath = void 0;
const datamodel_core_1 = require("@iotv/datamodel-core");
const effluentAreaCalculation_1 = require("../../DefinitionAndHelpers/Helpers/Effluent/effluentAreaCalculation");
const index_1 = require("../../DefinitionAndHelpers/index");
const typeName = 'EffluentPath';
class EffluentPath extends datamodel_core_1.ModelCommon {
    // extends DeviceEnabledType<SupportedDevices> {
    constructor(ob) {
        super(ob.type || typeName, ob);
        this.pathType = ob.pathType;
        this.throwDistance = ob.throwDistance;
        this.coverage = ob.coverage;
        this.path = ob.path;
        this.radius = ob.radius;
        this.name = ob.name;
        this.type = typeName;
        if (ob.pathType === index_1.EFFLUENT_PATH_TYPE.PivotEffluentSpreader) {
            if (ob.radius === 0 && ob.throwDistance !== 0) {
                this.radius = ob.throwDistance / 2;
                this.throwDistance = ob.throwDistance / 2;
            }
        }
    }
    constructPath(points) {
        switch (this.pathType) {
            case index_1.EFFLUENT_PATH_TYPE.PivotEffluentSpreader:
                if (points.length === 1) {
                    this.path = points;
                }
                break;
            case index_1.EFFLUENT_PATH_TYPE.LateralEffluentSpreader:
                let potentalMids = index_1.EffluentSpreaderHelper.convertMidLineForLateral(points);
                if (potentalMids !== undefined) {
                    this.path = potentalMids;
                }
                break;
            // case EFFLUENT_PATH_TYPE.TravellingEffluentSpreader:
            //   this.path = points;
            //   break;
            default:
                this.path = points;
                break;
        }
    }
    construstSpreadArea() {
        let res = { err: null, data: null };
        if (this.path) {
            let coverArea = [];
            let calculatedCover = [];
            switch (this.pathType) {
                case index_1.EFFLUENT_PATH_TYPE.PivotEffluentSpreader:
                    calculatedCover = (0, effluentAreaCalculation_1.convertPointTypePathToArea)(this.path, this.throwDistance, this.radius);
                    break;
                case index_1.EFFLUENT_PATH_TYPE.LateralEffluentSpreader:
                    calculatedCover = (0, effluentAreaCalculation_1.covertLateralPathToArea)(this.path, this.throwDistance, this.radius);
                    break;
                // case EFFLUENT_PATH_TYPE.TravellingEffluentSpreader:
                //   calculatedCover = convertLineTypePathToArea(this.path, this.throwDistance);
                //   break;
            }
            if (calculatedCover === undefined) {
                res.err = Error(`${this.pathType} coverage calculation failed`);
            }
            else {
                coverArea = calculatedCover;
            }
            this.coverage = coverArea;
            return { ...res, data: coverArea };
        }
        else {
            return { ...res, err: Error('No Path Found') };
        }
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            throwDistance: {
                type: 'Number',
                editable: true,
                label: 'Throw Radius (m)',
                required: true,
            },
            pathType: {
                type: 'Enum',
                enumKv: index_1.EFFLUENT_PATH_TYPE,
                editable: true,
                label: 'Supported Type',
                name: 'type',
                description: 'Effluent Run Support Type',
            },
            radius: {
                type: 'Number',
                editable: true,
                default: 0,
                label: 'Length Span (m)',
                required: true,
            },
        };
    }
}
exports.EffluentPath = EffluentPath;
